<template>
    <div id="main">
        <loader v-if="isLoading" />
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="listing-header">
            <div class="title-breadcrumb">
                <div class="title-breadcrumb">
                    <h1 class="title">
                        {{ $t("edita-vinculo-produto") }}
                    </h1>
                </div>
            </div>
            <div class="header-buttons">
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                >
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>

        <div class="columns is-flex-wrap">
            <div class="column is-6">
                <v-money
                    :id="generateId(1)"
                    ref="valorInput"
                    title="multiplicadorweb"
                    placeholder="placeholder-preencha"
                    :msg="'msg-campo-obrigatorio'"
                    :required="true"
                    :value="selectedInner.multiplicadorweb"
                    @input="multiplicadorwebUpdate"
                    :invalid="isNull(selectedInner.multiplicadorweb)"
                    :max="99999999"
                    :precision="precisionNumber"
                    tooltipLabel="informacao-multiplicador"
                    tooltipSize="is-small"
                    :disabled="blockEdit()"
                />
            </div>
            <div class="column is-6">
                <v-money
                    :id="generateId(2)"
                    ref="valorInput"
                    title="multiplicadortrocaweb"
                    placeholder="placeholder-preencha"
                    :msg="'msg-campo-obrigatorio'"
                    :required="true"
                    :value="selectedInner.multiplicadortrocaweb"
                    @input="multiplicadortrocawebUpdate"
                    :invalid="isNull(selectedInner.multiplicadortrocaweb)"
                    :max="99999999"
                    :precision="precisionNumber"
                    tooltipLabel="informacao-multiplicador-troca"
                    tooltipSize="is-small"
                    :disabled="blockEdit()"
                />
            </div>
            <div class="column is-12" v-if="blockEdit()">
                <h3>{{ $t("informacao-multiplicador-integracao") }}</h3>
            </div>
        </div>
    </div>
</template>

<script>
import ProdutoService from '@/services/vendas/empresa/abas/AssProdutoEmpresaService';
import Message from "@/models/Message";

export default {
    props: {
        selected: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            service: new ProdutoService(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            selectedInner: {
                idassprodutoempresa: null,
                multiplicadorweb: 0,
                multiplicadortrocaweb: 0,
            },
            precisionNumber: 5,

            isVenda: this.$route.meta.contexto == "vendas",
            isPromotor: this.$route.meta.contexto == "promotor",
        }
    },
    created() {
        this.selectedInner = Object.assign({}, this.selected);
    },
    methods: {
        blockEdit(){
            return (this.selected.multiplicador!=0&&this.selected.multiplicador!=1)
            ||
            (this.selected.multiplicadortroca!=0&&this.selected.multiplicadortroca!=1);
        },
        multiplicadorwebUpdate(value){
            this.selectedInner.multiplicadorweb = value;
        },
        multiplicadortrocawebUpdate(value){
            this.selectedInner.multiplicadortrocaweb = value;
        },

        generateId(numberId){
            return this.$route.name+'-produto-'+numberId;
        },
        save() {
            this.isLoading = true;

            this.updateProduto()
            .then(value => {
                if (value.content === null) {
                    this.msgs.push(new Message("error", `${value.message}`, true));
                } else {
                    this.$emit('fecharModal', true);
                }
            })
            .catch((e) => {
                this.msgs.push(new Message("alert", 'msg-erro-load', true));
            })
            .finally(() => {
                this.isLoading = false;
            });
        },
        updateProduto() {
            if (this.isVenda) return this.service.updateVendas(this.selectedInner);
            else if (this.isPromotor) return this.service.updatePromotor(this.selectedInner);
            else return this.service.updateAgro(this.selectedInner);
        }
    },
}
</script>


<style lang="scss" scoped>
#main {
    padding: 20px 20px;

    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}
</style>
